import createDecorator from 'final-form-calculate'
import { AtendimentoVacinacaoState, meta } from 'view/atendimentos/atendimento-vacinacao/model'

export const createVacinacaoCalculator = createDecorator(
  {
    field: meta.condicoesVacinacao.gestante.absolutePath(),
    updates: {
      [meta.condicoesVacinacao.puerpera.absolutePath()]: (gestanteValue, formValues: AtendimentoVacinacaoState) => {
        return gestanteValue ? false : formValues.condicoesVacinacao.puerpera
      },
    },
  },

  {
    field: meta.condicoesVacinacao.puerpera.absolutePath(),
    updates: {
      [meta.condicoesVacinacao.gestante.absolutePath()]: (puerperaValue, formValues: AtendimentoVacinacaoState) => {
        return puerperaValue ? false : formValues.condicoesVacinacao.gestante
      },
    },
  }
)
